import React from 'react';
import { Divider, Menu, MenuItem } from '@mui/material';
import { Link } from 'react-router';

import { getAnchorProps, MenuAnchor } from '@paragon/client-tools';
import { Station } from '@paragon/contract-library';
import { hasSupervisorFeatureFlag } from '@paragon/login-tools';

import {
  showEditStationDialog,
  showPermanentLinksDialog,
  showStationInsertionDialog,
} from '../../../actions/dialogActions';
import { deleteStation, unInsertStation } from '../../../actions/supervisorActions';
import { useAppDispatch, useAppSelector } from '../../hooks';

export function StationMenu(props: {
  station: Station;
  lineGuid?: string;

  anchor: MenuAnchor;
  onClose: () => void;
}) {
  const dispatch = useAppDispatch();
  const isSupervisor = useAppSelector(hasSupervisorFeatureFlag);

  const url = props.lineGuid
    ? `/lines/${props.lineGuid}/stations/${props.station.guid}`
    : `/stations/${props.station.guid}`;

  return (
    <Menu open={props.anchor != null} {...getAnchorProps(props.anchor)} onClose={props.onClose}>
      {isSupervisor && [
        <MenuItem
          key="add-to-line"
          onClick={() => {
            props.onClose();
            dispatch(showStationInsertionDialog(props.station.guid, props.lineGuid));
          }}
        >
          Add to {props.lineGuid && 'another'} line
        </MenuItem>,
        <MenuItem
          key="rename"
          onClick={() => {
            props.onClose();
            dispatch(showEditStationDialog(props.station.guid));
          }}
        >
          Rename station
        </MenuItem>,

        props.lineGuid ? (
          <MenuItem
            key="remove"
            onClick={() => {
              props.onClose();
              dispatch(unInsertStation(props.station.guid, props.lineGuid!));
            }}
          >
            Remove from this line
          </MenuItem>
        ) : null,

        <MenuItem
          key="delete"
          onClick={async () => {
            props.onClose();
            dispatch(deleteStation(props.station));
          }}
        >
          Delete {props.lineGuid ? 'and remove from all lines' : 'station'}
        </MenuItem>,

        <Divider key="divider" />,

        <MenuItem
          key="get-permanent-link"
          onClick={() => {
            props.onClose();
            dispatch(showPermanentLinksDialog(props.station.guid));
          }}
        >
          Manage permanent links
        </MenuItem>,
      ]}

      <MenuItem component={Link} to={url} onClick={props.onClose}>
        Go to station page
      </MenuItem>
    </Menu>
  );
}
